import { z } from "zod";
import { reportMetricIds } from "./metrics.js";
export const reportColumnIds = [
    ...reportMetricIds,
    "duration",
    "firstSeen",
];
export const reportColumnIdSchema = z.enum(reportColumnIds);
export const reportSortDirectionSchema = z.enum(["asc", "desc"]);
export const reportSortSchema = z
    .object({
    direction: reportSortDirectionSchema,
    metric: z.enum(reportMetricIds),
})
    .strict();
export const reportSortsSchema = z
    .array(reportSortSchema)
    .min(1)
    .max(4)
    .superRefine((sorts, context) => {
    if (new Set(sorts.map(({ metric }) => metric)).size !== sorts.length) {
        context.addIssue({
            code: "custom",
            message: "Report sort metrics must be unique",
        });
    }
});
const selectedReportColumnsSchema = z
    .array(reportColumnIdSchema)
    .min(1)
    .max(reportColumnIds.length)
    .superRefine((columnIds, context) => {
    if (new Set(columnIds).size !== columnIds.length) {
        context.addIssue({
            code: "custom",
            message: "Report columns must be unique",
        });
    }
});
export const replaceReportPreferencesRequestSchema = z
    .object({ columnIds: selectedReportColumnsSchema })
    .strict();
export const reportPreferencesResponseSchema = replaceReportPreferencesRequestSchema
    .extend({ updatedAt: z.iso.datetime({ offset: true }).nullable() })
    .strict();
export const DEFAULT_REPORT_COLUMN_IDS = Object.freeze([
    "spend",
    "impressions",
    "ctr",
    "purchases",
    "roas",
    "hookRate",
    "holdRate",
    "duration",
    "firstSeen",
]);
export const DEFAULT_REPORT_SORTS = Object.freeze([
    Object.freeze({ direction: "desc", metric: "spend" }),
]);
//# sourceMappingURL=report-preferences.js.map